<script>
import canAutoplay from 'can-autoplay';
import UAParser from 'ua-parser-js';

export default {
	props: {
		type: {
			type: String,
			required: true,
		},
		item: {
			type: String,
			required: true,
		},
		fallback: {
			type: String,
			required: false,
		},
		isSubPage: Boolean,
	},
	data() {
		return {
			showFallback: false,
			videoIsPlaying: false,
			UA: new UAParser(),
		};
	},
	computed: {
		videoHtml() {
			return `<video src="${this.item}" playsinline autoplay muted loop></video>`;
		},
	},
	mounted() {
		// Always allow video autoplay on chrome or iOS (by request of client - this isn't bulletproof)
		if (this.UA.getBrowser().name === 'Chrome' || this.UA.getOS().name === 'iOS') {
			this.showFallback = false;
			this.playVideo();
		} else {
			this.playVideo();
			canAutoplay.video({ timeout: 200, muted: true })
				.then(({ result }) => {
					const videoCurrentTime = (this.$refs.video)
						? this.$refs.video.currentTime
						: 0;
					if (result !== true && videoCurrentTime === 0) {
						this.showFallback = true;
					}
				});
		}
	},
	methods: {
		playVideo() {
			if (this.$refs.video && !this.videoIsPlaying) {
				this.$refs.video.muted = true;
				try {
					this.$refs.video.play();
				} catch (e) {
					console.error('[RoHeader]: automatic video play() not allowed', e);
				}
			}
		},
		videoPlaying() {
			this.videoIsPlaying = true;
		},
	},
};
</script>

<style src="./RoHeader.scss"></style>
<template src="./RoHeader.html"></template>



// WEBPACK FOOTER //
// RoHeader.vue?78921de2